import useCurrentUser from "APP_ROOT/hooks/useCurrentUser";

export const getLocationNameById = id => {
  if (!id) return null;
  const user = useCurrentUser();
  return user.locations.filter(l => l.id === id)[0].name;
};



// WEBPACK FOOTER //
// ./app/modules/Locations/helpers.js